export default "__VITE_ASSET__n7tT7rre__"